// pt-PT source of truth for the teams area (Equipas de Investigação / Linhas Temáticas).
export const teams = {
  // Contadores partilhados de membros / equipas (interpolados).
  members: '{n} membros',
  memberOne: '1 membro',
  teamsCount: '{n} equipas',
  teamOne: '1 equipa',

  list: {
    title: 'Equipas de Investigação',
    linesTitle: 'Linhas Temáticas',
    subtitle: 'Equipas de Investigação e Linhas Temáticas',
    syncedAt: 'sincronizado {date}',
    neverSynced: 'nunca sincronizado',
    sync: 'Sincronizar',
    syncing: 'A sincronizar…',
    syncFailed: 'Sincronização do SISTRADE falhou: {error}',
    readFailed: 'Não foi possível ler do SISTRADE: {error}',
    searchPlaceholder: 'Pesquisar por equipa, linha temática ou responsável…',
    emptyTeams: 'Sem equipas de investigação.',
    emptyLines: 'Sem linhas temáticas.',
    source: {
      rest: 'SISTRADE',
      sql: 'SISTRADE (BD)',
      hybrid: 'SISTRADE',
      stub: 'Dados de demonstração',
      none: 'Sem ligação',
    },
  },

  equipa: {
    membersLabel: 'Membros',
    piNames: 'PI: {names}',
    copiNames: 'CO-PI: {names}',
    lineBadge: 'Linha Temática',
    noMembers: 'Sem membros na origem de dados atual.',
    lineTeams: 'Equipas de Investigação desta linha',
    noTeams: 'Sem equipas de investigação associadas.',
    roleInUnit: 'Função na Unidade FCT',
    dedicationTitle: '% Dedicação',
    dedicationText: '{n}% dedicação',
    entryTitle: 'Data de entrada na equipa (SISTRADE)',
    entryText: 'desde {date}',
    memberCode: 'Código do colaborador (ficha)',
  },

  myteam: {
    title: 'A minha equipa',
    subtitle:
      'Registos que iniciou — o estado avança à medida que o Onboarding / RH os validam e lançam.',
    newRecord: 'Novo Registo',
    records: '{n} registos',
    recordOne: '1 registo',
    filterByStatus: 'Filtrar por estado',
    allStatuses: 'Todos os estados',
    empty: 'Ainda não iniciou nenhum registo. Use “Novo Registo”.',
    colName: 'Nome',
    colEmail: 'Email',
    colStatus: 'Estado',
    colReceived: 'Recebido',
  },
};
